module.exports = __webpack_public_path__ + "img/warning-hexagon.e75a35d6.svg";